import { AvailableIconTypes } from '@ui/Icon';
import { StudioProjectVersion } from '../../server/graphql/__generated.types';

const AZURE_PROJECT_VERSIONS_PREFIX = 'azure_';

export const getProjectVersionInfo = (
  version: StudioProjectVersion,
  showCarusoLegacy?: boolean
) => {
  let v2Label = 'Caruso';
  if (showCarusoLegacy) v2Label = 'Caruso (Legacy)';
  switch (version) {
    case StudioProjectVersion.Legacy:
      return {
        displayName: 'Standard',
        isBeta: false,
      };
    case StudioProjectVersion.ScriptStudio:
    case StudioProjectVersion.V2:
      return {
        displayName: v2Label,
        isBeta: false,
      };
    case StudioProjectVersion.ExtCanva:
      return {
        displayName: 'Canva',
        isBeta: false,
      };
    case StudioProjectVersion.ExtAdobe:
      return {
        displayName: 'Adobe',
        isBeta: false,
      };
    case StudioProjectVersion.AzureFrench:
    case StudioProjectVersion.AzureGerman:
    case StudioProjectVersion.AzureItalian:
    case StudioProjectVersion.AzurePortuguese:
    case StudioProjectVersion.AzureSpanish:
    case StudioProjectVersion.AzureJapanese:
    case StudioProjectVersion.AzureKorean:
    case StudioProjectVersion.AzureChinese:
    case StudioProjectVersion.AzureArabic:
    case StudioProjectVersion.AzurePersian:
    case StudioProjectVersion.AzureTurkish:
    case StudioProjectVersion.AzureDutch:
    case StudioProjectVersion.AzureCzech:
    case StudioProjectVersion.AzurePolish:
    case StudioProjectVersion.AzureDanish:
    case StudioProjectVersion.AzureSwedish:
      return {
        displayName: getAzureProjectDisplayName(version),
        isBeta: false,
      };
    default:
      return {
        displayName: version,
        isBeta: false,
      };
  }
};

const getAzureProjectDisplayName = (version: StudioProjectVersion) => {
  if (version.startsWith(AZURE_PROJECT_VERSIONS_PREFIX)) {
    const language = version.substring(AZURE_PROJECT_VERSIONS_PREFIX.length);
    return language.charAt(0).toUpperCase() + language.slice(1);
  }

  return version;
};

export const isAzureVoiceProjectVersion = (version: StudioProjectVersion) => {
  return version.startsWith(AZURE_PROJECT_VERSIONS_PREFIX);
};

export const getAzureProjectVersion = (value: string) => {
  const possibleVersions = Object.values(StudioProjectVersion).filter(v =>
    v.startsWith('azure_')
  );
  return possibleVersions.find(v => getAzureProjectDisplayName(v) === value);
};

export const getProjectVersionIcon = (
  version: StudioProjectVersion
): AvailableIconTypes => {
  switch (version) {
    case StudioProjectVersion.Legacy:
      return 'recording02';
    case StudioProjectVersion.ScriptStudio:
    case StudioProjectVersion.V2:
      return 'carusoLogomark';
    case StudioProjectVersion.ExtAdobe:
    case StudioProjectVersion.ExtCanva:
      return 'puzzlePiece02';

    default:
      return 'globe02';
  }
};
